import { css } from '@emotion/css';
import { useTheme } from '@mui/material/styles';

export default function createEmotionStyles(styleCreator) {
  return function useEmotionStyles() {
    const theme = useTheme();
    const styles =
      typeof styleCreator === 'function' ? styleCreator(theme) : styleCreator;

    return Object.fromEntries(
      Object.entries(styles).map(([name, style]) => [name, css(style)])
    );
  };
}
